import { render } from "./mediaList.vue?vue&type=template&id=72e5d33e&scoped=true&ts=true"
import script from "./mediaList.vue?vue&type=script&lang=ts"
export * from "./mediaList.vue?vue&type=script&lang=ts"

import "./mediaList.vue?vue&type=style&index=0&id=72e5d33e&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72e5d33e"]])

export default __exports__